export default {
  0: 'Company',
  1: 'Customer',
  2: 'Contact',
  3: 'Vendor',
  4: 'Insurer',
  5: 'UserProfile',
  6: 'Superannuation',
  7: 'CustomerCompany'
}
